export { IconSpeed } from "./IconSpeed";
